import { render, staticRenderFns } from "./QueueItemDetail.vue?vue&type=template&id=6817598c&scoped=true&"
import script from "./QueueItemDetail.vue?vue&type=script&lang=js&"
export * from "./QueueItemDetail.vue?vue&type=script&lang=js&"
import style0 from "./QueueItemDetail.vue?vue&type=style&index=0&id=6817598c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6817598c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6817598c')) {
      api.createRecord('6817598c', component.options)
    } else {
      api.reload('6817598c', component.options)
    }
    module.hot.accept("./QueueItemDetail.vue?vue&type=template&id=6817598c&scoped=true&", function () {
      api.rerender('6817598c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/meeting-agendas/items/QueueItemDetail.vue"
export default component.exports